import { render, staticRenderFns } from "./NlpHowItWorksImageMobile.vue?vue&type=template&id=6f91aba6&scoped=true"
import script from "./NlpHowItWorksImageMobile.vue?vue&type=script&lang=js"
export * from "./NlpHowItWorksImageMobile.vue?vue&type=script&lang=js"
import style0 from "./NlpHowItWorksImageMobile.vue?vue&type=style&index=0&id=6f91aba6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f91aba6",
  null
  
)

export default component.exports